export default __webpack_public_path__ + "static/media/icon_venues_bw.bb90fc7a.svg";